import { render } from "./ParcoursUnite.vue?vue&type=template&id=6c00bcfa&scoped=true&ts=true"
import script from "./ParcoursUnite.vue?vue&type=script&lang=ts"
export * from "./ParcoursUnite.vue?vue&type=script&lang=ts"

import "./ParcoursUnite.vue?vue&type=style&index=0&id=6c00bcfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c00bcfa"]])

export default __exports__